import Notification from './Notification.component';

export default Notification;
